export class ForgotPwd {
  constructor(
    public code?: string,
    public newPassword?: string,
    public confirmPassword?: string,
    public username?: string,
  ) {  }
}
